'use client';
import cn from 'classnames';
import styles from './ProductSlider.module.scss';
import { Swiper, SwiperClass, SwiperSlide } from 'swiper/react';
import { useRef } from 'react';
import { SliderArrows } from '@/atoms/SliderArrows';
import { ProductType } from '@/types';
import { ProductCard } from '@/components/ProductCard';
import { useAdaptiveLayout } from '@/hooks/useAdaptiveLayout';
import 'swiper/css';

type ProductSliderProps = {
  className?: string;
  items: ProductType[];
  title: string;
};

export function ProductSlider({ className, items, title }: ProductSliderProps) {
  const wrapperClassName = cn(styles.wrapper, className);
  const swiperRef = useRef<SwiperClass | null>(null);
  const { isTablet } = useAdaptiveLayout();

  const handleNextPage = () => {
    if (swiperRef.current) {
      swiperRef.current.slideNext();
    }
  };

  const handlePrevPage = () => {
    if (swiperRef.current) {
      swiperRef.current.slidePrev();
    }
  };

  return (
    <div className={wrapperClassName}>
      <div className={styles.header}>
        <span className={styles.title}>{title}</span>
        <SliderArrows
          onPrevClick={handlePrevPage}
          onNextClick={handleNextPage}
        />
      </div>
      <Swiper
        className={styles.slider}
        effect="slide"
        slidesPerView="auto"
        loop
        onSwiper={(swiper) => (swiperRef.current = swiper)}
        spaceBetween={isTablet ? 16 : 36}
        grabCursor
      >
        {items.map((product, index) => (
          <SwiperSlide key={index} className="custom-slide">
            <ProductCard product={product} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
